import React from 'react'
import Link from '../../components/Link'

const BlogPage = () => {
  return (
    <div className="container">
      <div
        className="blog"
        style={{ margin: '0 auto', maxWidth: '70ch', marginBottom: '5em' }}
      >
        <Link href="/blog/20-march">&#8592; Previous</Link>
        <h2>Don’t stockpile your prayers</h2>
        <span className="author">by Jon Shulver, 25 March 2020</span>
        <p>
          In Jesus’ model prayer to “Our Father in Heaven” he says these words:
          “Give us today our daily bread.”
        </p>
        <p>
          They are familiar words to many. Just look at them for a moment
          though. Have you considered the strong emphasis on today? “Give us
          today our daily bread” It’s not “Give us today what we need for the
          coming week or month.” It’s not asking in advance – so we’ve no need
          to come back to “Our Father in Heaven” tomorrow. No, it’s a daily
          request for our Father to meet our needs for today. We aren’t to
          stockpile our prayer requests. We are to pray daily, for our daily
          needs.
        </p>
        <p>
          Right now it will be for our good if we put that into practice. It’s
          so easy to worry about tomorrow, next week, the next twelve weeks, the
          year and the future. But Jesus calls us to trust God with today. That
          doesn’t mean we are never to plan or make preparations. It doesn’t
          mean as Christians we’re not to long for the amazing future when we
          will be with Jesus and everything will be made right. But we need not
          worry about tomorrow. Jesus tells us plainly in Matthew 7:34
          <i>
            “Therefore do not worry about tomorrow, for tomorrow will worry
            about itself.”
          </i>
          &nbsp;Let’s be honest, much of our worry and anxiety is about tomorrow
          not today, it’s about the future not the present. As the pastor Kevin
          DeYoung says “Anxiety is living out the future before it gets here.”
        </p>
        <p>
          Can I encourage you to bring your daily needs to your Father in
          Heaven? To trust that his provision and grace will be sufficient for
          today. Let’s not play out scenarios in our minds about tomorrow, we
          can come back to our Father tomorrow with tomorrow’s concerns. Let’s
          live, as best we can, one day at a time.
        </p>
        <p>
          And here’s the good news. Each day as we come to our Heavenly Father,
          his love and faithfulness are new and fresh. They are never changing.
          We haven’t got to seek his love today fearing that his love may have
          run out in the future, that tomorrow he won’t have mercy on us. As the
          writer of Lamentations says
          <i>
            “The steadfast love of the Lord never ceases; his mercies never come
            to an end; they are new every morning; great is your faithfulness.
            The Lord is my portion, says my soul, therefore I will hope in him.”
          </i>
        </p>
        <p>Trust your Heavenly Father with today.</p>
        <p>And tomorrow, you can confidently do the same</p>
      </div>
    </div>
  )
}

export default BlogPage



// WEBPACK FOOTER //
// ./src/pages/blog/25-march.js